import { Box, Icon, Typography } from "@mui/material"
import { icons } from "../../../utils/icons"
import { useStyles } from "./styles"

function NoHistorial({ label, footer }: { label: string, footer: string }) {
  const styles = useStyles()
  return (
    <Box sx={styles.noResponse}>
      <Icon>{icons('Watch')}</Icon>

      <Typography variant="subtitle" fontWeight='500'>{label}</Typography>
      <Typography variant="footer" fontWeight='500'>{footer}</Typography>
    </Box>
  )
}

export { NoHistorial }